export const KYC_STATUS_OPTIONS = [
  { label: "Pending", value: "pending" },
  { label: "Submitted", value: "submitted" },
  { label: "Approved", value: "approved" },
  { label: "Rejected", value: "rejected" },
  { label: "Under Review", value: "under_review" },
];

export const ORDER_OPTIONS = [
  { label: "Newest First", value: "desc" },
  { label: "Oldest First", value: "asc" },
];

export const CARD_STATUS = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
  { label: "Pending", value: "pending" },
  { label: "Closed", value: "closed" },
  { label: "Frozen", value: "frozen" },
  { label: "Cancelled", value: "cancelled" },
]

export const PHYSICAL_CARD_STATUS = [
  { label: "Pending", value: "pending" },
  { label: "Processing", value: "processing" },
  { label: "Shipped", value: "shipped" },
  { label: "Delivered", value: "delivered" },
]